<template>
  <div class="admin__home">
    <Header />
    <div class="notfound">
      <div>
        <div class="notfound__text">
          <span>ERROR CODE: 404</span>
          <h1>Oops!!</h1>
          <h2>This is not the page you are looking for</h2>
          <p>Here are some helpful links instead:</p>
          <div>
            <div class="notfound__text--left">
              <routerLink to="/dashboard">Dashboard</routerLink>
            </div>
            <div class="notfound__text--right">
              <routerLink to="/dashboard">Message to Account Officer</routerLink>
            </div>
          </div>
        </div>
        <div class="notfound__image">
          <img src="./../../assets/images/404.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../partials/header";

export default {
  name: "Notfound",
  components: {
    Header
  }
};
</script>

<style lang="scss" scoped>
.notfound {
  background-color: #fbfafa;
  min-width: 1000px;
  padding-top: 70px;
  padding-bottom: 100px;

  > div {
    width: 63.438vw;
    margin: auto;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding: 64px 53px 85px 108px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
    align-content: center;

    > .notfound__text {
      width: 22.083vw;
      object-fit: contain;

      > span {
        font-size: 0.833vw;
        font-weight: 200;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.5;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > h1 {
        font-size: 4.167vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 0.5;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > h2 {
        font-size: 2.188vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > p {
        font-size: 1.25vw;
        font-weight: 200;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > div {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        > .notfound__text--left {
          width: 5.208vw;
          font-size: 0.938vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 2.22;
          letter-spacing: normal;
          text-align: left;
          color: #5099de;

          > a {
            color: #5099de;
            text-decoration: none;
          }
        }

        > .notfound__text--right {
          width: 12.24vw;
          font-size: 0.938vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 2.22;
          letter-spacing: normal;
          text-align: left;
          color: #5099de;

          > a {
            color: #5099de;
            text-decoration: none;
          }
        }
      }
    }

    > .notfound__image {
      width: 19.323vw;
      object-fit: contain;
    }
  }
}
</style>